import { Children } from 'react';
import { BreadcrumbsMenu } from './BreadcrumbsMenu';
import { Container } from './styled';
const NEST_CHILDREN_THRESHOLD = 3;
export function Breadcrumbs(props) {
    const { children } = props;
    const childrenAmount = Children.count(children);
    const nestChildren = childrenAmount > NEST_CHILDREN_THRESHOLD;
    return nestChildren ? <BreadcrumbsMenu>{children}</BreadcrumbsMenu> : <Container>{children}</Container>;
}
